module.exports = __webpack_public_path__ + "static/media/thumb_7.db26d610.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Images/thumb_7.png
// module id = 83
// module chunks = 0